import { useRef, useEffect } from "react"

// Hook for closing the Popup component
// Listens for 'Esc' keydown event and when user presses outside of the component
export const useClosePopup = (handler) => {
  let domNode = useRef()

  useEffect(() => {
    // Same as for 'maybeHandler' but checks if the user pressed the 'Esc' key
    let handleKeyPress = (event) => {
      if(event.key === "Escape") {
        handler()
      }
    }
  
    document.addEventListener("keydown", handleKeyPress)

    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  },[handler])

  return domNode
}